import Business from '@constants/Business'
import { postLink, postImage } from '@components/blog/utils/postLinks'
import schemaDate from './helpers/schemaDate'
import blogSchemaGenre from './helpers/blogSchemaGenre'

export default function blogArticle (article) {
    const { title = '', author = '', shortDesc = '', docType = '', created } = article
    const url = Business.host + postLink(article)
    const date = schemaDate(created)

    return {
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        "isAccessibleForFree": true,
        "headline": title,
        "image": Business.host + postImage(article),
        "author": {
            "@type": "Person",
            "name": author,
        },
        "editor": author,
        "genre": blogSchemaGenre(docType),
        "publisher": {
            "@type": "Organization",
            "name": "dostawczaki.pl",
            "logo": {
                "@type": "ImageObject",
                "url": Business.host + '/assets/icons/large-samochody-fb.jpeg'
            }
        },
        "url": url,
        "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": url,
        },
        "datePublished": date,
        "dateCreated": date,
        "dateModified": date,
        "description": shortDesc,
    }
}